<template>
    <div class="department-page-wrap" v-loading="loading">
        <div class="aside-left">
            <div
                :class="{ active: departmentForm.did == '' }"
                class="aside-title flex"
                @click.stop="handleClickCompanyName"
            >
                <img
                    alt=""
                    :src="
                        company_logo
                            ? company_logo
                            : 'https://download.hecoos.com/enlightv/2024-50/6919ee7c360932f1a3d707340824fc36.png'
                    "
                />
                <span class="ellipsis">{{ company_name }}</span>
                <span>（{{ total_users }}）</span>
                <el-tooltip content="新建部门" effect="dark" placement="top" v-if="hasOperatePermission">
                    <i
                        class="iconfont handle_icon_wrap icon-a-tianjiamiaobian"
                        @click.stop="handleClickAddChildDep()"
                    ></i>
                </el-tooltip>
            </div>
            <div class="tree-wrap thin-scrollbar">
                <el-tree
                    :allow-drop="allowDrop"
                    :data="departmentList"
                    :expand-on-click-node="false"
                    :highlight-current="departmentForm.did ? true : false"
                    :props="{ children: 'children', label: 'department_name' }"
                    check-on-click-node
                    default-expand-all
                    draggable
                    node-key="id"
                    @node-drop="handleDrop"
                    @node-click="handleClickDepNode"
                >
                    <div slot-scope="{ node, data }" class="custom-tree-node">
                        <span class="ellipsis">{{ node.label }}</span>
                        <span v-if="data.user_count">（{{ data.user_count }}）</span>
                        <div class="custom-tree-icon" @click.stop>
                            <el-dropdown
                                placement="bottom-end"
                                size="small"
                                trigger="click"
                                v-if="hasOperatePermission"
                            >
                                <span class="icon_wrap"><i class="el-icon-more"></i></span>
                                <el-dropdown-menu class="treeDropDown" slot="dropdown">
                                    <el-dropdown-item @click.native="handleClickAddChildDep(data)" v-if="data.level < 5"
                                        >添加子部门
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickEditCate(data)">编辑 </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickDelCate(data)">删除 </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </el-tree>
            </div>
        </div>
        <div class="content-right">
            <div class="page-filter_wrap">
                <div class="page-filter_wrap_left">
                    <el-input
                        placeholder="请输入需要查询的内容"
                        v-model="searchForm.keyword"
                        class="filter-input"
                        clearable
                        @clear="handleClickSearch"
                        @keyup.enter.native="handleClickSearch"
                    >
                        <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                    </el-input>
                    <ListAdvancedFiltering
                        :field_form="'users'"
                        :field_list="formInfoList"
                        @sendFilterData="getFilterData"
                        :system_fields="systemFilterFields"
                    />
                </div>
                <div class="page-filter_wrap_right">
                    <template v-if="selectIds && selectIds.length">
                        <el-button @click="handleClickChangeDep" v-if="hasUpdateUserDepartmentPermission"
                            >变更部门</el-button
                        >
                        <el-button @click="handleClickInvitProfile">邀请完善信息</el-button>
                    </template>
                    <template v-if="guideCompleteStatus == 3">
                        <el-dropdown placement="bottom" trigger="click">
                            <div class="more_operate_icon">更多 <i class="el-icon-arrow-down"></i></div>
                            <el-dropdown-menu slot="dropdown">
                                <!-- <el-dropdown-item @click.native="handleMoreOptionsChange('import')"
                                    >导入花名册</el-dropdown-item
                                > -->
                                <el-dropdown-item @click.native="handleMoreOptionsChange('export')"
                                    >导出</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>

                        <el-button
                            type="primary"
                            plain
                            @click="handleClickInvit"
                            v-auth="'person.addInviteLink'"
                            permission_type="person"
                            route_name="DepartmentPersonnel"
                            >邀请加入</el-button
                        >
                        <el-button type="primary" v-if="hasOperatePermission" @click="handleAddMember"
                            >新增员工</el-button
                        >
                    </template>
                    <template v-if="guideCompleteStatus == 1 && hasOperatePermission">
                        <el-button type="primary" @click="handleClickAddTip">添加人员</el-button>
                    </template>
                </div>
            </div>
            <div class="page-table">
                <p class="filter-count" v-if="filterCount && !selectIds.length">共{{ pagination.total }}条</p>
                <CustomVxeTable
                    id="departmentTabel"
                    ref="customTable"
                    :class="{ 'custom-table': filterCount && !selectIds.length }"
                    :customConfig="tableCustomConfig"
                    :isShowToolBar="true"
                    :pagination="pagination"
                    :reduceHeight="reduceHeight"
                    :tableData="tableData"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    :rowId="'user_id'"
                    :checkboxConfig="{ reserve: true }"
                    @checkbox-all="handleSelectionChange"
                    @checkbox-change="handleSelectionChange"
                    :tooltip-config="tooltipConfig"
                >
                    <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>

                    <vxe-column
                        v-for="field in formInfoList"
                        :key="field.field_key"
                        :align="field.align ? 'right' : 'left'"
                        :field="field.field_key"
                        :title="field.field_name"
                        show-overflow
                        :min-width="getFieldWidth(field.field_type)"
                        :fixed="field.field_key === 'name' ? 'left' : undefined"
                    >
                        <template #default="{ row }">
                            <div
                                v-if="field.field_key === 'name'"
                                class="link-label"
                                @click.stop="handleClickConfirmMember(row)"
                            >
                                <el-tooltip
                                    v-if="row.entry_status == 1"
                                    class="yiwen_tooltip_item"
                                    effect="dark"
                                    content="该员工已填写入职信息，请核实信息无误后，操作【确认入职】加入公司"
                                    placement="top-start"
                                >
                                    <span class="handle_icon_wrap handle_icon_yellow_wrap">
                                        <i class="iconfont icon-yiwen"></i>
                                    </span>
                                </el-tooltip>
                                <el-tooltip
                                    v-if="row.is_active == 0 && row.entry_status == 0"
                                    class="yiwen_tooltip_item"
                                    effect="dark"
                                    content="该员工未注册澜精灵账号，请发送登录链接给员工"
                                    placement="top-start"
                                >
                                    <span class="handle_icon_wrap handle_icon_yellow_wrap">
                                        <i class="iconfont icon-yiwen"></i>
                                    </span>
                                </el-tooltip>
                                <span v-text="row.name"></span>
                                <el-tooltip
                                    v-if="row.is_department_head"
                                    class="yiwen_tooltip_item"
                                    effect="dark"
                                    content="部门负责人"
                                    placement="top-start"
                                >
                                    <span class="handle_icon_wrap handle_icon_yellow_wrap" style="margin-left: 4px">
                                        <i class="iconfont icon-bumenfuzeren1"></i>
                                    </span>
                                </el-tooltip>
                            </div>
                            <div v-else>
                                <div v-if="field.field_type === 'contact'">
                                    <div v-if="row[field.field_key].length">
                                        <div v-for="item in row[field.field_key]" class="custom_contact_field_wrap">
                                            <PersonnelCard :userId="item.id" v-if="item.id">
                                                <template slot="container">
                                                    <img
                                                        :src="item.avatar ? item.avatar : defaultImg"
                                                        alt=""
                                                        class="avatar"
                                                    />
                                                    <span class="name" v-text="item.name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'department'">
                                    <div v-if="row[field.field_key].length">
                                        <div v-for="item in row[field.field_key]">
                                            <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                                <span v-text="item.department_name"></span>
                                            </el-tooltip>
                                        </div>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'radio'">
                                    <span
                                        v-if="row[field.field_key]"
                                        :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                        v-text="row[field.field_key]"
                                    ></span>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'checkbox'">
                                    <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <template v-if="field.extend.tag_interaction">
                                            <span
                                                v-for="item in row[field.field_key].slice(0, 2)"
                                                :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                                v-text="item"
                                            >
                                            </span>
                                            <span class="is_tag_interaction">+{{ row[field.field_key].length }}</span>
                                        </template>
                                        <template v-else>
                                            <span>{{ row[field.field_key].join(",") }} </span>
                                        </template>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'checkbox_user_tag'">
                                    <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                        <span
                                            v-for="item in row[field.field_key]"
                                            class="is_tag_interaction"
                                            v-text="item.name"
                                        >
                                        </span>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'image'">
                                    <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                        <el-image
                                            :preview-src-list="row[field.field_key].map((img) => img.file_path)"
                                            :src="row[field.field_key][0].file_path"
                                            fit="cover"
                                        >
                                        </el-image>
                                        <el-popover
                                            :visible-arrow="false"
                                            placement="bottom-start"
                                            popper-class="table_custom_image_popover"
                                            title=""
                                            trigger="hover"
                                            width="254"
                                        >
                                            <div slot="reference">
                                                <span
                                                    v-if="row[field.field_key].length > 1"
                                                    class="image_count"
                                                    v-text="`+${row[field.field_key].length - 1}`"
                                                ></span>
                                            </div>
                                            <ul class="image_list">
                                                <li
                                                    v-for="(img, img_index) in row[field.field_key]"
                                                    :key="img_index"
                                                    class="image_item"
                                                >
                                                    <el-image
                                                        :preview-src-list="
                                                            row[field.field_key].map((img) => img.file_path)
                                                        "
                                                        :src="img.file_path"
                                                        fit="cover"
                                                    >
                                                    </el-image>
                                                </li>
                                            </ul>
                                        </el-popover>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'file'">
                                    <div v-if="row[field.field_key].length"></div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'invoice'">
                                    <div v-if="row[field.field_key].length"></div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'relate_approve_form'"></div>
                                <div v-else-if="field.field_type === 'id_card'">
                                    <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                        <span v-text="row[field.field_key].value"></span>
                                        <el-popover
                                            placement="bottom"
                                            popper-class="id_card_detail_popper"
                                            trigger="click"
                                            width="380"
                                        >
                                            <span slot="reference" class="handle_icon_wrap" style="margin-left: 10px">
                                                <i class="iconfont icon-shenfenzheng"></i>
                                            </span>
                                            <el-form size="small">
                                                <el-row>
                                                    <el-col :span="24">
                                                        <el-form-item
                                                            v-if="row[field.field_key].name"
                                                            label="姓名"
                                                            prop="name"
                                                        >
                                                            <span v-text="row[field.field_key].name"></span>
                                                        </el-form-item> </el-col
                                                    ><br />
                                                    <el-col :span="24">
                                                        <el-form-item
                                                            v-if="row[field.field_key].birthday"
                                                            label="出生日期"
                                                            prop="birthday"
                                                        >
                                                            <span v-text="row[field.field_key].birthday"></span>
                                                        </el-form-item>
                                                    </el-col>
                                                    <el-col :span="24">
                                                        <el-form-item
                                                            v-if="row[field.field_key].address"
                                                            label="家庭住址"
                                                            prop="name"
                                                        >
                                                            <span v-text="row[field.field_key].address"></span>
                                                        </el-form-item>
                                                    </el-col>
                                                    <el-col :span="24">
                                                        <el-form-item label="身份证号" prop="value">
                                                            <span v-text="row[field.field_key].value"></span>
                                                        </el-form-item>
                                                    </el-col>
                                                </el-row>
                                            </el-form>
                                            <img
                                                alt=""
                                                class="ic_card_icon"
                                                src="https://download.hecoos.com/enlightv/2025-02/02d922ef5bd0a7ded22b965632d634ea.png"
                                            />
                                        </el-popover>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'paying_teller'">
                                    <div
                                        v-if="row[field.field_key] && row[field.field_key].text"
                                        class="custom_paying_teller_field_wrap"
                                    >
                                        <span v-text="row[field.field_key].text"></span>
                                        <el-popover
                                            placement="bottom"
                                            popper-class="paying_teller_detail_popper"
                                            trigger="click"
                                            width="350"
                                        >
                                            <span slot="reference" class="handle_icon_wrap">
                                                <i class="iconfont icon-zhanghu"></i>
                                            </span>
                                            <el-form class="custom_detail_form" label-position="top" size="small">
                                                <el-form-item label="账户类型" prop="account_type">
                                                    <span
                                                        v-text="
                                                            row[field.field_key].account_type === 1
                                                                ? '个人账户'
                                                                : '对公账户'
                                                        "
                                                    ></span>
                                                </el-form-item>
                                                <el-form-item label="户名" prop="account_name">
                                                    <span v-text="row[field.field_key].account_name"></span>
                                                </el-form-item>
                                                <el-form-item label="账号" prop="card_number">
                                                    <span v-text="row[field.field_key].card_number"></span>
                                                </el-form-item>
                                                <el-form-item label="所属银行" prop="bank_name">
                                                    <span v-text="row[field.field_key].bank_name"></span>
                                                </el-form-item>
                                                <el-form-item
                                                    v-if="field.extend.bank_branch_is_show"
                                                    label="银行支行"
                                                    prop="bank_branch"
                                                >
                                                    <span v-text="row[field.field_key].bank_branch"></span>
                                                </el-form-item>
                                            </el-form>
                                        </el-popover>
                                    </div>
                                    <span v-else>--</span>
                                </div>
                                <div v-else-if="field.field_type === 'table'"></div>
                                <span v-else v-text="row[field.field_key] ? row[field.field_key] : '--'"></span>
                            </div>
                        </template>
                    </vxe-column>
                    <vxe-column field="operate" width="90" fixed="right">
                        <template #header>
                            <span>操作</span>
                            <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                            </el-tooltip>
                        </template>
                        <template #default="{ row }">
                            <el-dropdown placement="bottom" trigger="click">
                                <el-button icon="el-icon-more" type="text"></el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <!--  is_active 是否激活 0=否 1=是-->
                                    <!--  entry_status 邀请入职状态 0=正常 1=待入职-->
                                    <!-- 1. 如果是未激活 和 邀请入职状态不是待入职 ，说明是直接新增的，用户没有登录，此时可以取消，可以取消添加-->
                                    <!-- 2. 如果是未激活 和 邀请入职状态是待入职 , 说明是直接走的邀请，此时可以取消，可以确认入职,确认的时候改为已激活状态-->
                                    <!-- 3. 如果是已激活 和 邀请入职状态不是待入职。 说明走的直接新增，并且已经登陆了，此时不可以取消，应该是已经入职了-->
                                    <!-- 4. 如果是已激活 和 邀请入职状态是待入职。 说明走的邀请，并且无法登录已经登陆了，这种状态为错误数据-->
                                    <template v-if="row.quit_info && row.quit_info.id && hasQuitPermission">
                                        <!-- 待离职 -->
                                        <el-dropdown-item @click.native="handleClickLeaveConfirmQuit(row)">
                                            确认离职</el-dropdown-item
                                        >
                                        <el-dropdown-item @click.native="handleClickLeaveCancelQuit(row)">
                                            取消离职</el-dropdown-item
                                        >
                                        <el-dropdown-item @click.native="handleClickLeaveOfficeEdit(row)"
                                            >修改离职信息</el-dropdown-item
                                        >
                                    </template>
                                    <template v-else>
                                        <el-dropdown-item
                                            v-if="row.profile_edit && row.profile_edit.uid"
                                            @click.native="handleClickConfirmInfo(row)"
                                            >信息确认</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            v-if="row.entry_status == 1 && hasConfirmEntryPermission"
                                            @click.native="handleClickConfirmEntry(row)"
                                            >确认入职</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            v-if="row.entry_status == 1 && hasCancelEntryPermission"
                                            @click.native="handleClickCancelEntry(row)"
                                            >取消入职</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            v-if="hasOperatePermission"
                                            @click.native="handleClickEditMember(row)"
                                            >信息编辑</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            v-if="row.is_active == 0 && row.entry_status == 0"
                                            @click.native="handleClickCancelAdd(row)"
                                            >取消添加</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            v-if="
                                                row.is_active == 1 &&
                                                row.entry_status == 0 &&
                                                (!row.profile_edit || !row.profile_edit.uid) &&
                                                hasUpdateUserDepartmentPermission
                                            "
                                            @click.native="handleClickChangeDep(row)"
                                            >变更部门</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            @click.native="handleClickLeaveOffice(row)"
                                            v-if="row.is_active == 1 && row.entry_status == 0 && hasApplyQuitPermission"
                                            >办理离职</el-dropdown-item
                                        >
                                        <el-dropdown-item
                                            @click.native="handleClickInvitProfile(row)"
                                            v-if="
                                                row.is_active == 1 &&
                                                row.entry_status == 0 &&
                                                (!row.profile_edit || !row.profile_edit.uid)
                                            "
                                            >邀请完善信息</el-dropdown-item
                                        >
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </vxe-column>
                    <template #empty>
                        <div class="custom-table-empty">
                            <div class="custom-table-empty-img">
                                <img
                                    src="https://download.hecoos.com/enlightv/2025-09/79aca5659d09f1a8f1161d7106c3ecf6.png"
                                    alt=""
                                />
                            </div>
                            <p class="custom-table-empty-txt">暂无数据</p>
                        </div>
                    </template>
                </CustomVxeTable>
            </div>
        </div>
        <div class="guide-tip-dialog" v-if="guideCompleteStatus == 2">
            <div class="btns-box">
                <!-- <span>导入花名册</span> -->
                <span>邀请加入</span>
                <span>新增员工</span>
            </div>
            <div class="tooltip-popper">
                <p>后续您可以根据自己的需求在此处选择添加员工的方式！</p>
                <el-button type="primary" @click="handleClickChangeGuideStatus(3)">我知道了</el-button>
            </div>
        </div>
        <addMemberGuide
            v-if="guideDialogVisible"
            ref="addMemberGuide"
            :guideDialogVisible.sync="guideDialogVisible"
            @handleClickAddMember="handleAddMember"
            @handleClickChangeGuideStatus="handleClickChangeGuideStatus(2)"
            @handleClickInvit="handleClickInvit"
        />
        <editDepartment
            v-if="addEditDepartmentDialog"
            :addEditDepartmentDialog.sync="addEditDepartmentDialog"
            ref="editDepartment"
            :dialogType="dialogType"
            :departmentInfo="departmentInfo"
            @success="getDepartmentList"
        />
        <changeDepartment
            v-if="dialogDepartmentVisible"
            ref="changeDepartment"
            :dialogDepartmentVisible.sync="dialogDepartmentVisible"
            :change_department_user_id="change_department_user_id"
            @success="changeDepartmentSuccess"
        />
        <leaveOffice
            :leaveDialogVisible.sync="leaveDialogVisible"
            :user_info="user_info"
            v-if="leaveDialogVisible"
            @success="handleClickSearch"
            ref="leaveOffice"
        />
        <addMember
            v-if="addMemberDialogVisible"
            ref="addMember"
            :addMemberDialogVisible.sync="addMemberDialogVisible"
            @success-callback="_getFromFields"
        />
        <editMember
            v-if="editMemberDialogVisible"
            ref="editMember"
            :editMemberDialogVisible.sync="editMemberDialogVisible"
            :user_id="user_id"
            @success-callback="_getFromFields"
        />
        <confirmMember
            v-if="confirmMemberDialogVisible"
            ref="confirmMember"
            :confirmMemberDialogVisible.sync="confirmMemberDialogVisible"
            :type="confirmMemberType"
            :user_id="user_id"
            :profile_edit="profile_edit"
            @success-callback="_getFromFields"
        />
        <invit v-if="dialogInvitVisible" ref="invit" :dialogInvitVisible.sync="dialogInvitVisible" />
        <el-dialog
            v-if="deleteDepartmentDialog"
            :before-close="handleDeleteDepartmentDialogClose"
            :close-on-click-modal="false"
            :visible.sync="deleteDepartmentDialog"
            class="custom-dialog custom-tooltip-confirm-dialog custom-department-tooltip-dialog"
            title=""
            width="390px"
        >
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao"></i>
                <div>
                    <p class="tooltip-confirm-title">
                        {{ deleteDepartmentTitle }}
                    </p>
                    <p>{{ deleteDepartmentContent }}</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleDeleteDepartmentDialogClose">取消</el-button>
                <el-button type="danger" @click="handleDeleteDepartmentDialogConfirm">确定</el-button>
            </span>
        </el-dialog>
        <resignationDetail
            :resignationDetailDialogVisible.sync="resignationDetailDialogVisible"
            @success="getTableData"
            :user_info="user_info"
            v-if="resignationDetailDialogVisible"
        />
    </div>
</template>
<script>
import * as XLSX from "xlsx";
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import addMemberGuide from "./component/member_add_guide.vue";
import editDepartment from "./component/department_edit.vue";
import changeDepartment from "./component/department_change.vue";
import leaveOffice from "../component/leave_office.vue";
import addMember from "./component/member_add.vue";
import editMember from "./component/member_edit.vue";
import confirmMember from "../component/member_confirm.vue";
import invit from "./component/invit.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import resignationDetail from "../dimission_manage/component/resignation_detail.vue";

import {
    GetCompanyDepartmentList,
    getFormFields,
    getUserListPage,
    DepartmentDel,
    DepartmentEdit,
    confirmEntry,
    cancelEntry,
    CreateProfileEdit,
    confirmQuit,
    cancelQuit,
    ConfirmProfileEdit,
    getUserDetail,
    GuideMarkRead,
    GetGuideReadList,
    CheckUserAuthDepartment,
} from "@/api";
import { tableDataFieldShow } from "@/utils";
import { pagination } from "@/mixins";
import { mapGetters, mapState } from "vuex";

export default {
    name: "DepartmentPersonnel",
    components: {
        ListAdvancedFiltering,
        CustomVxeTable,
        addMemberGuide,
        editDepartment,
        changeDepartment,
        leaveOffice,
        addMember,
        editMember,
        confirmMember,
        invit,
        PersonnelCard,
        resignationDetail,
    },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            guideCompleteStatus: 1, // 引导状态 1-未查看引导页 2-已查看引导页，当前处于提示框，3-后续操作
            confirmMemberType: "look",
            company_name: "",
            company_logo: "",
            departmentForm: {
                did: "",
                didTitle: "",
            },
            departmentList: [],
            total_users: 0,
            searchForm: {
                keyword: "",
                type: 1,
            },
            selectMoreStatus: "",
            selectIds: [],
            // reduceHeight: 170,
            tableData: [],
            dialogType: "", // 添加、编辑部门弹框类型
            deleteDepartmentDialog: false,
            deleteDepartmentTitle: "删除部门",
            deleteDepartmentContent: "删除部门后不可恢复！该部门所关联的相关业务将全部清空，请谨慎操作！",
            dialogInvitVisible: false,
            dialogDepartmentVisible: false,
            guideDialogVisible: false,
            addMemberDialogVisible: false,
            confirmMemberDialogVisible: false,
            editMemberDialogVisible: false,
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "checkbox";
                },
                checkMethod: (col) => {
                    return col.column.field !== "name";
                },
                allowSort: true,
            },
            tooltipConfig: {
                contentMethod: ({ column, row }) => {
                    if (column.field === "user_tag_id") {
                        return row["user_tag_id"].map((item) => item.name).join("、");
                    }
                },
            },
            pagination: {
                pageNum: 1,
                pageSize: 15,
                pageSizes: [15, 30, 50, 100],
                layout: "total, prev, pager, next, sizes, jumper",
                total: 0,
            },
            user_id: 0,
            profile_edit: false, // 是否为邀请编辑过的
            formInfoList: [],
            systemFilterFields: [
                {
                    field_type: "radio",
                    field_key: "u.gender",
                    is_system: 1,
                    field_name: "性别",
                    system_type: "system",
                    options: [
                        {
                            label: "男",
                            value: 1,
                        },
                        {
                            label: "女",
                            value: 2,
                        },
                    ],
                },
                {
                    field_type: "date",
                    field_key: "u.joined_date",
                    is_system: 1,
                    field_name: "入职日期",
                    system_type: "system",
                    date_type: "date",
                },
                {
                    field_type: "checkbox_user_tag",
                    post_field_type: "radio",
                    field_key: "utr.user_tag_id",
                    is_system: 1,
                    field_name: "人员标签",
                    system_type: "system",
                },
                {
                    field_type: "contact",
                    field_key: "u.superior_id",
                    is_system: 1,
                    field_name: "直属上级",
                    system_type: "system",
                },
                {
                    field_type: "department",
                    field_key: "u.department_id",
                    is_system: 0,
                    field_name: "部门",
                    system_type: "system",
                },
            ],
            personTagOptions: [],
            custom_filter: {},
            departmentInfo: null,
            addEditDepartmentDialog: false,
            change_department_user_id: [], //变更部门

            leaveDialogVisible: false,
            user_info: null,
            // 离职人员信息
            resignationDetailDialogVisible: false,
        };
    },
    mixins: [pagination],
    computed: {
        filterCount() {
            const custom_filter = this.custom_filter;
            if (custom_filter == {}) {
                return false;
            } else if (
                (custom_filter.custom_field && custom_filter.custom_field.length) ||
                (custom_filter.logic_field && custom_filter.logic_field.length) ||
                (custom_filter.system_field && custom_filter.system_field.length)
            ) {
                return true;
            }
        },
        reduceHeight() {
            return this.filterCount ? 200 : this.tableData.length ? 170 : 120;
        },
        ...mapState(["userInfo"]),
        ...mapGetters(["hasPermission"]),
        // 操作权限：可对部门和人员进行新增、编辑、变更、导出、删除部门的操作；因为后台权限设置的是同一个按钮，所以判断一个权限的类型就行，如果之后权限分开了之后，就需要判断某一个按钮的权限了；目前我这里根据部门新增的权限判断的
        hasOperatePermission() {
            return this.hasPermission("department.departmentAdd", "person", "DepartmentPersonnel");
        },
        // 管理权限-批量更改用户的所属部门
        hasUpdateUserDepartmentPermission() {
            return this.hasPermission("person.UpdateUserDepartment", "person", "DepartmentPersonnel");
        },
        // 离职权限：确认离职、取消离职、修改离职信息权限
        hasQuitPermission() {
            return this.hasPermission("person.confirmQuit", "person", "DepartmentPersonnel");
        },
        // 确认入职
        hasConfirmEntryPermission() {
            return this.hasPermission("person.confirmEntry", "person", "DepartmentPersonnel");
        },
        // 取消入职
        hasCancelEntryPermission() {
            return this.hasPermission("person.cancelEntry", "person", "DepartmentPersonnel");
        },
        // 办理离职
        hasApplyQuitPermission() {
            return this.hasPermission("person.applyQuit", "person", "DepartmentPersonnel");
        },
    },
    created() {
        this.getGuideReadList();
        this.getDepartmentList();
        this._getFromFields();
        if (this.$route.query && this.$route.query.id) {
            getUserDetail({
                user_id: this.$route.query.id,
            }).then((res) => {
                if (res.code === 200) {
                    const row = res.data;
                    this.handleClickConfirmMember(row);
                }
            });
        }
    },
    methods: {
        // 获取已读的引导图
        getGuideReadList() {
            GetGuideReadList().then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    if (data && data.length) {
                        if (data.includes("person_guide")) {
                            this.guideCompleteStatus = 3;
                        } else {
                            this.guideCompleteStatus = 1;
                        }
                    } else {
                        this.guideCompleteStatus = 1;
                    }
                }
            });
        },
        //获取自定义字段列表
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "users",
                filter_field_type: "form_module",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.formInfoList = res.data;
                        this.getTableData();
                    } else {
                        this.$message.error(res.message);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getFieldWidth(field_type) {
            if (field_type == "id_card" || field_type === "paying_teller") {
                return "210";
            } else if (field_type == "checkbox") {
                return "160";
            } else {
                return "150";
            }
        },
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = val.pageSize;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        //获取表格数据
        getTableData() {
            getUserListPage({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                custom_filter: this.custom_filter,
                department_id: this.departmentForm.did,
            }).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.tableData = data;
                    this.pagination.total = total;
                    tableDataFieldShow(this.formInfoList, this.tableData);
                }
            });
        },
        //获取高级筛选数据
        getFilterData(data) {
            this.selectIds = [];
            this.custom_filter = data;
            this.getTableData();
        },
        //获取部门列表
        getDepartmentList() {
            this.loading = true;
            GetCompanyDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.total_users = res.data.total_users;
                    this.departmentList = res.data.departments || [];
                    this.company_logo = res.data.company_logo;
                    this.company_name = res.data.company_name;
                    this.departmentInfo = null;
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },
        // 表格复选框
        handleSelectionChange({ records, reserves }) {
            this.selectIds = [...reserves, ...records];
        },
        // 更多操作
        handleMoreOptionsChange(type) {
            if (type === "import") {
                // 导入花名册
                this.$router.push({
                    name: "ImportRoster",
                    params: {
                        isPush: true,
                    },
                });
            } else {
                // 导出
                this.handleClickExport();
            }
        },
        // 导出
        handleClickExport() {
            if (this.selectIds.length) {
                this.xlsxToExcel(this.selectIds);
            } else {
                let params = {
                    page: 1,
                    pageSize: this.pagination.total,
                    keyword: this.searchForm.keyword,
                    custom_filter: this.custom_filter,
                    department_id: this.departmentForm.did,
                };
                this.loading = true;
                getUserListPage(params)
                    .then((res) => {
                        if (res.code === 200) {
                            var { data } = res.data;
                            tableDataFieldShow(this.formInfoList, data);
                            this.$nextTick(() => {
                                this.xlsxToExcel(data);
                            });
                        } else {
                            this.loading = false;
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        },
        xlsxToExcel(data) {
            let tableData = [];
            let HeaderInfo = [];
            HeaderInfo = this.formInfoList.map((item) => item.field_name);
            tableData = data.map((row) => {
                let itemdata = [];
                this.formInfoList.forEach((field) => {
                    if (field.field_key === "name") {
                        itemdata.push(row.name);
                    } else if (field.field_type === "contact") {
                        const contactData =
                            row[field.field_key] && row[field.field_key].length
                                ? row[field.field_key].map((contact) => contact.name).join("、")
                                : "--";
                        itemdata.push(contactData);
                    } else if (field.field_type === "department") {
                        itemdata.push(
                            row[field.field_key] && row[field.field_key].length
                                ? row[field.field_key].map((department) => department.full_path).join("、")
                                : "--"
                        );
                    } else if (field.field_type === "radio") {
                        itemdata.push(row[field.field_key] || "--");
                    } else if (field.field_type === "checkbox") {
                        itemdata.push(row[field.field_key].length ? row[field.field_key].join("、") : "--");
                    } else if (field.field_type === "checkbox_user_tag") {
                        itemdata.push(
                            row[field.field_key].length ? row[field.field_key].map((tag) => tag.name).join("、") : "--"
                        );
                    } else if (field.field_type === "image") {
                        itemdata.push("--");
                    } else if (field.field_type === "file") {
                        itemdata.push("--");
                    } else if (field.field_type === "invoice") {
                        itemdata.push("--");
                    } else if (field.field_type === "relate_approve_form") {
                        itemdata.push("--");
                    } else if (field.field_type === "id_card") {
                        itemdata.push("--");
                    } else if (field.field_type === "paying_teller") {
                        itemdata.push("--");
                    } else if (field.field_type === "table") {
                        itemdata.push("--");
                    } else {
                        itemdata.push(row[field.field_key] ? row[field.field_key] : "--");
                    }
                    itemdata.push();
                });
                return itemdata;
            });
            const xlsxData = [HeaderInfo, ...tableData];
            const ws = XLSX.utils.aoa_to_sheet(xlsxData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            const fileName = this.nowDate();
            setTimeout(() => {
                XLSX.writeFile(wb, fileName);
                this.$message.success("导出成功");
                this.loading = false;
            }, 2000);
        },
        nowDate(type) {
            const today = new Date();
            const year = today.getFullYear();
            let month = today.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            if (type && type == "date") {
                return `${year}-${month}-${date}`;
            } else if (type && type == "date2") {
                return `${year}-${month}`;
            } else {
                return `人员组织${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
            }
        },
        handleClickChangeGuideStatus(state) {
            this.guideCompleteStatus = state;
        },
        handleClickCustom() {
            this.$refs.customTable.handleOpenCustomShow();
        },
        allowDrop(draggingNode, dropNode, type) {
            // console.log(draggingNode, dropNode, type)
            return true;
        },
        handleDrop(draggingNode, dropNode, dropType, ev) {
            let postData = {};
            if (dropType === "inner") {
                // console.log(`${draggingNode.label} 被放置到了 ${dropNode.label} 的下一级`);
                postData.id = draggingNode.data.id;
                postData.pid = dropNode.data.id;
            } else if (dropType === "before") {
                postData.id = draggingNode.data.id;
                postData.pid = dropNode.data.pid;
                // console.log(`${draggingNode.label} 被放置到了 ${dropNode.label} 之前`);
            } else if (dropType === "after") {
                postData.id = draggingNode.data.id;
                postData.pid = dropNode.data.pid;
                // console.log(`${draggingNode.label} 被放置到了 ${dropNode.label} 之后`);
            }
            postData.department_name = draggingNode.data.department_name;
            postData.department_heads = draggingNode.data.heads.map((map) => {
                return map.uid;
            });
            let sort_array = this.recursionSortFunction(JSON.parse(JSON.stringify(this.departmentList)));
            postData.sort_array = sort_array;
            this.loading = true;
            DepartmentEdit(postData).then((res) => {
                if (res.code === 200) {
                    this.$message({
                        type: "success",
                        message: res.message,
                        duration: 1500,
                        onClose: () => {},
                    });
                    this.getDepartmentList();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        recursionSortFunction(data) {
            return data.map((item, key) => {
                const result = { id: item.id, sort: key + 1 };
                // 如果有子项，则递归转换
                if (item.children) {
                    result.children = this.recursionSortFunction(item.children);
                }
                return result;
            });
        },
        handleClickDepNode(data) {
            this.departmentForm.did = data.id;
            this.getTableData();
        },
        checkColumnMethod({ column }) {
            return true;
        },
        // 点击公司查询详情
        handleClickCompanyName() {
            this.departmentForm.did = "";
            this.departmentForm.didTitle = "";
            this.getTableData();
        },
        // 添加子部门
        handleClickAddChildDep(data) {
            this.dialogType = "add";
            this.departmentInfo = data ? data : { department_name: this.company_name };
            this.addEditDepartmentDialog = true;
        },
        // 编辑部门
        handleClickEditCate(data) {
            this.dialogType = "edit";
            this.departmentInfo = data;
            this.addEditDepartmentDialog = true;
        },
        // 删除部门
        handleClickDelCate(data) {
            if (data.children.length || this.pagination.total) {
                // 有子级或有在职人员
                const h = this.$createElement;
                this.$msgbox({
                    title: "删除失败",
                    message: h("div", null, [h("span", null, "该部门下包含子部门/在职人员，请完成转移后再进行删除！")]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                    customClass: "prompt_message_custom",
                    confirmButtonText: "知道了",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: false,
                    showClose: false,
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            done();
                        } else {
                            done();
                        }
                    },
                })
                    .then(() => {})
                    .catch(() => {});
            } else {
                this.departmentInfo = data;
                this.deleteDepartmentDialog = true;
            }
        },
        // 删除部门弹框
        handleDeleteDepartmentDialogClose() {
            this.departmentInfo = null;
            this.deleteDepartmentDialog = false;
        },
        // 删除部门弹框确认
        handleDeleteDepartmentDialogConfirm() {
            this.deleteDepartmentDialog = false;
            DepartmentDel({ id: this.departmentInfo.id }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);
                    this.getDepartmentList();
                }
            });
        },
        // 添加人员引导页弹框
        handleClickAddTip() {
            this.isLookTip = true;
            this.guideDialogVisible = true;
            GuideMarkRead({ guide_name_en: "person_guide" }).then((res) => {
                if (res.code === 200) {
                }
            });
        },
        // 新增员工
        handleAddMember() {
            this.addMemberDialogVisible = true;
        },
        // 编辑信息
        handleClickEditMember(row) {
            this.user_id = row.user_id;
            this.editMemberDialogVisible = true;
        },
        // 点击头像操作的
        handleClickConfirmMember(row) {
            if (row.quit_info && row.quit_info.id) {
                // 待离职
                this.user_info = {
                    id: row.quit_info.id,
                    user_id: row.quit_info.uid,
                    user_name: row.name,
                    department_path:
                        row.department_id && row.department_id.length ? row.department_id[0].full_path : "",
                    avatar: row.avatar,
                    quit_status: row.quit_info.quit_status,
                };
                this.resignationDetailDialogVisible = true;
            } else {
                let type = row.entry_status == 1 ? "PendingJoin" : row.is_active == 0 ? "unregistered" : "";

                this.user_id = row.user_id;
                // 判断是否需要确认
                // row.profile_edit.uid != this.userInfo.user.id 暂时先不判断权限
                this.profile_edit = row.profile_edit && row.profile_edit.id ? true : false;
                if (this.profile_edit) {
                    type = "confirm";
                }
                this.confirmMemberType = type;
                this.confirmMemberDialogVisible = true;
            }
        },
        // 信息确认
        handleClickConfirmInfo(row) {
            ConfirmProfileEdit({ user_id: row.profile_edit.uid }).then((res) => {
                if (res.code === 200) {
                    this.$message({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.getTableData();
                        },
                    });
                }
            });
        },
        // 确认入职
        handleClickConfirmEntry(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: "确认入职",
                message: h("div", null, [h("span", null, "确认入职后，该员工加入公司，账号立即生效！ ")]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                showClose: false,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    let postData = {
                        user_id: row.user_id,
                    };
                    this.loading = true;
                    confirmEntry(postData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("操作成功");
                            this.getTableData();
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 取消入职
        handleClickCancelEntry(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: "取消入职",
                message: h("div", null, [h("span", null, "取消入职后，如需再次加入公司需重新邀请或新增员工。 ")]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                showClose: false,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    let postData = {
                        user_id: row.user_id,
                    };
                    this.loading = true;
                    cancelEntry(postData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("操作成功");
                            this.getTableData();
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 取消添加
        handleClickCancelAdd(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: "取消添加",
                message: h("div", null, [h("span", null, "取消添加后，如需再次加入公司需重新邀请或新增员工。")]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                showClose: false,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    let postData = {
                        user_id: row.user_id,
                    };
                    this.loading = true;
                    cancelEntry(postData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("操作成功");
                            this.getTableData();
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 变更部门
        handleClickChangeDep(row) {
            if (row && row.user_id) {
                this.change_department_user_id = [row.user_id];
            } else {
                this.change_department_user_id = this.selectIds.map((item) => {
                    return item.user_id;
                });
            }
            CheckUserAuthDepartment({ user_ids: this.change_department_user_id }).then((res) => {
                if (res.code === 200) {
                    if (res.data.del) {
                        // 可更改
                        this.dialogDepartmentVisible = true;
                    } else {
                        // 不可更改
                        const h = this.$createElement;
                        this.$msgbox({
                            title: "变更提示",
                            message: h("div", null, [h("span", null, res.data.msg)]),
                            iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                            customClass: "prompt_message_custom",
                            confirmButtonText: "确定",
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            confirmButtonClass: "",
                            showClose: false,
                            beforeClose: (action, instance, done) => {
                                if (action === "confirm") {
                                    done();
                                } else {
                                    done();
                                }
                            },
                        }).then((res) => {
                            this.dialogDepartmentVisible = true;
                        });
                    }
                }
            });
        },
        // 变更部门回调
        changeDepartmentSuccess() {
            this.selectIds = [];
            this.getTableData();
        },
        // 办理离职
        handleClickLeaveOffice(row) {
            this.user_info = {
                user_id: row.user_id,
                user_name: row.name,
                department_path: row.department_id && row.department_id.length ? row.department_id[0].full_path : "",
                avatar: row.avatar,
            };
            this.leaveDialogVisible = true;
        },
        // 邀请加入
        handleClickInvit() {
            this.dialogInvitVisible = true;
        },
        // 邀请完善信息
        handleClickInvitProfile(row) {
            let selectIds = [];
            if (row && row.user_id) {
                // 单个邀请完善
                selectIds = [row];
                this.selectIds = selectIds;
            }
            if (!this.selectIds.length) return this.$message.warning("请至少选择一个人员");
            const h = this.$createElement;
            this.$msgbox({
                title: "邀请完善信息",
                message: h("div", null, [
                    h(
                        "span",
                        null,
                        "邀请后，将通知对应人员完善员工档案，可在【后台管理-设置字段】中设置员工档案字段，及入职登记表所填字段"
                    ),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                confirmButtonText: "邀请",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                showClose: false,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    this.loading = true;
                    const postData = this.selectIds.map((item) => ({ user_id: item.user_id }));
                    CreateProfileEdit({ users: postData }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("操作成功");
                            this.getTableData();
                            this.selectIds = [];
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 确认离职
        handleClickLeaveConfirmQuit(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: "确认离职",
                message: h("div", null, [
                    h("span", null, "确认离职后，该员工的帐号将关闭，请确保工作交接已完成！！！"),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                showClose: false,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    let postData = {
                        id: row.quit_info.id,
                    };
                    this.loading = true;
                    confirmQuit(postData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("操作成功");
                            this.getTableData();
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 取消离职
        handleClickLeaveCancelQuit(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: "取消离职",
                message: h("div", null, [h("span", null, "取消离职后，该员工将恢复为正常在职状态。")]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                showClose: false,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    let postData = {
                        id: row.quit_info.id,
                    };
                    this.loading = true;
                    cancelQuit(postData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getTableData();
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 离职信息修改
        handleClickLeaveOfficeEdit(row) {
            this.user_info = {
                id: row.quit_info.id,
                user_id: row.quit_info.uid,
                user_name: row.name,
                department_path: row.department_id && row.department_id.length ? row.department_id[0].full_path : "",
                avatar: row.avatar,
            };
            this.leaveDialogVisible = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.department-page-wrap {
    width: 100%;
    height: 100%;
    display: flex;

    .aside-left {
        width: 290px;
        flex-shrink: 0;
        padding: 16px 8px;

        .aside-title {
            padding: 5px 30px 5px 8px;
            border-radius: 4px;
            align-items: center;
            position: relative;
            cursor: pointer;

            img {
                width: 16px;
                height: 16px;
                border-radius: 4px;
                margin-right: 8px;
            }

            span {
                font-size: 14px;
                font-weight: 700;
                color: rgba(34, 34, 34, 1);
                line-height: 22px;
            }

            .iconfont {
                position: absolute;
                top: 5px;
                right: 8px;
                width: 22px;
                height: 22px;
                font-size: 16px;
                text-align: center;
                line-height: 22px;
                color: #2990ff;
                &:hover {
                    color: #4ba2ff;
                }
                &:active {
                    color: #2279d6;
                }
            }

            &:hover,
            &:active,
            &.active {
                background-color: rgba(0, 0, 0, 0.08);
            }
        }

        .tree-wrap {
            margin-top: 3px;
            height: calc(100% - 32px);

            & > .el-tree {
                height: calc(100% - 2px);
                overflow-y: auto;
            }

            ::v-deep {
                .el-tree-node__expand-icon {
                    color: rgba(102, 102, 102, 1);
                }

                .el-tree-node__expand-icon.is-leaf {
                    color: transparent !important;
                }

                .el-tree-node__content {
                    border-radius: 6px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(102, 102, 102, 1);
                    height: 38px;
                }

                .el-tree-node__children .el-tree-node__content,
                .el-tree > .el-tree-node__content,
                .el-tree-node > .el-tree-node__content {
                    &:hover,
                    &:active {
                        background-color: rgba(0, 0, 0, 0.04);
                        color: rgba(51, 51, 51, 1);
                    }
                }

                .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
                    background-color: rgba(41, 144, 255, 0.16);
                    font-size: 14px;
                    font-weight: 700;
                    color: rgba(41, 144, 255, 1);
                }

                .custom-tree-node {
                    line-height: 22px;
                    position: relative;
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    padding-right: 25px;

                    .custom-tree-icon {
                        opacity: 0;
                        position: absolute;
                        right: 8px;
                        top: 0;
                        width: 22px;
                        height: 22px;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .el-icon-more {
                            font-size: 16px;
                            color: rgba(102, 102, 102, 1);
                        }

                        &:hover {
                            background-color: rgba(0, 0, 0, 0.04);

                            .el-icon-more {
                                color: rgba(51, 51, 51, 1);
                            }
                        }

                        &:active,
                        &.active {
                            background-color: rgba(0, 0, 0, 0.04);

                            .el-icon-more {
                                color: rgba(34, 121, 214, 1);
                            }
                        }
                    }
                    &:hover {
                        .custom-tree-icon {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }

    .content-right {
        flex: 1;
        padding: 16px;
        border-left: 1px solid rgba(232, 232, 232, 1);
        overflow: hidden;
    }

    .filter-count {
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .custom-table {
        ::v-deep {
            .vxe-table {
                margin-top: 8px;
            }
        }
    }
    .page-filter_wrap_right {
        .more_operate_icon {
            margin: 0 16px;
            width: 78px;
            height: 32px;
            box-sizing: border-box;
            border-radius: 4px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(217, 217, 217, 1);
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            cursor: pointer;
        }
    }
}

.guide-tip-dialog {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    overflow: auto;
    margin: 0;
    z-index: 2002;
    padding: 54px 20px 0 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .btns-box {
        width: 309px;
        height: 32px;
        opacity: 1;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        display: flex;
        justify-content: space-between;

        span {
            border-radius: 4px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(41, 144, 255, 1);
            padding: 5px 16px;
            color: rgba(41, 144, 255, 1);

            &:last-child {
                background: rgba(41, 144, 255, 1);
                color: rgba(255, 255, 255, 1);
            }
        }
    }

    .tooltip-popper {
        width: 268px;
        height: 108px;
        margin-right: 21px;
        margin-top: 12px;
        opacity: 1;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);
        border-radius: 6px;
        padding: 16px 12px;

        p {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }

        .el-button {
            float: right;
            margin-top: 12px;
            padding: 2px 5px;
            line-height: 18px;
            font-size: 12px;
        }
    }
}
</style>
<style lang="scss">
@import "@/styles/filter-form-wrap.scss";

.treeDropDown {
    margin-top: 5px !important;

    .popper__arrow {
        display: none;
    }

    .el-dropdown-menu__item {
        text-align: center;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 4px;

        &:hover {
            background-color: rgba(0, 0, 0, 0.04);
            color: rgba(51, 51, 51, 1);
        }

        &:active {
            background-color: rgba(41, 144, 255, 0.08);
            color: rgba(41, 144, 255, 1);
        }
    }
}

.custom-department-tooltip-dialog {
    .el-dialog__body {
        min-height: 110px;
        padding-bottom: 0 !important;

        .el-button--text {
            padding: 0;
            border: 0;
        }
    }
}

.yiwen_tooltip_item {
    margin-right: 4px;
    margin-top: -3px;
    i {
        color: rgba(251, 173, 19, 1);
    }
}
</style>
